import type React from 'react';
import type {
  HomepageDesignSystemSettings,
  HomepageSectionBackground,
  HomepageSectionMaxWidth,
  HomepageSectionPadding,
  HomepageSectionSettings,
} from './sectionRegistry';

export function getHomepageSectionWrapperClasses(settings?: HomepageSectionSettings): {
  outer: string;
  inner: string;
  outerStyle?: React.CSSProperties;
};
export function getHomepageSectionWrapperClasses(
  settings?: HomepageSectionSettings,
  designSystem?: HomepageDesignSystemSettings
): {
  outer: string;
  inner: string;
  outerStyle?: React.CSSProperties;
} {
  const resolvedPaddingTop =
    settings?.paddingTop ??
    settings?.padding ??
    designSystem?.sectionSpacing ??
    'none';
  const resolvedPaddingBottom =
    settings?.paddingBottom ??
    settings?.padding ??
    designSystem?.sectionSpacing ??
    'none';
  const maxWidth = settings?.maxWidth ?? designSystem?.containerMaxWidth ?? 'full';
  const background = settings?.background ?? designSystem?.sectionBackground ?? 'default';

  const paddingTopClassMap: Record<HomepageSectionPadding, string> = {
    none: '',
    sm: 'pt-4',
    md: 'pt-8',
    lg: 'pt-12',
    xl: 'pt-16',
  };

  const paddingBottomClassMap: Record<HomepageSectionPadding, string> = {
    none: '',
    sm: 'pb-4',
    md: 'pb-8',
    lg: 'pb-12',
    xl: 'pb-16',
  };

  const maxWidthClassMap: Record<HomepageSectionMaxWidth, string> = {
    full: 'max-w-none',
    xl: 'max-w-7xl',
    lg: 'max-w-6xl',
    md: 'max-w-4xl',
  };

  const backgroundClassMap: Record<HomepageSectionBackground, string> = {
    default: 'bg-transparent',
    muted: '',
    accent: '',
  };

  let outerStyle: React.CSSProperties | undefined;
  if (background === 'muted') {
    outerStyle = { backgroundColor: designSystem?.mutedBackgroundColor ?? '#f5f5f4' };
  } else if (background === 'accent') {
    outerStyle = { backgroundColor: designSystem?.accentBackgroundColor ?? '#eff6ff' };
  }

  return {
    outer: [
      'w-full',
      backgroundClassMap[background],
      paddingTopClassMap[resolvedPaddingTop],
      paddingBottomClassMap[resolvedPaddingBottom],
    ].filter(Boolean).join(' '),
    inner: ['mx-auto w-full', maxWidthClassMap[maxWidth]].join(' '),
    outerStyle,
  };
}
